export default __webpack_public_path__ + "static/media/PremiumBreakBenefit.c2c04ebb.png";